import React, { memo } from 'react';
import { FormSection, FormInput } from '@/components';
import { CreateResourceFormData, CreateResourceFormErrors } from '@/components/admin/resources/CreateResource/hooks/useCreateResourceForm';

interface ResourceContentSectionProps {
  formData: CreateResourceFormData;
  errors: CreateResourceFormErrors;
  onFieldChange: (field: keyof CreateResourceFormData, value: string) => void;
}

export const ResourceContentSection = memo<ResourceContentSectionProps>(({
  formData,
  errors,
  onFieldChange,
}) => {
  return (
    <FormSection 
      title="Content"
      subtitle="Additional content and links for your resource"
    >
      <FormInput
        label="Content"
        value={formData.content}
        onChangeText={(value) => onFieldChange('content', value)}
        placeholder="Additional text content (optional)"
        error={errors.content}
        multiline
        numberOfLines={4}
        autoCapitalize="sentences"
        autoCorrect
      />
      
      <FormInput
        label="URL"
        value={formData.url}
        onChangeText={(value) => onFieldChange('url', value)}
        placeholder="https://example.com (optional)"
        error={errors.url}
        autoCapitalize="none"
        autoCorrect={false}
        keyboardType="url"
      />
    </FormSection>
  );
});

ResourceContentSection.displayName = 'ResourceContentSection';